import React from 'react'
import injectStyles from 'react-jss'

const styles = injectStyles({
  note: {
    fontSize: 11,
    opacity: 0.8,
  },
})

const Note = ({ hidden = false, children, cypress_id }) => {
  if (hidden) return null
  return (
    <div style={styles.note} cypress_id={cypress_id}>
      {children}
    </div>
  )
}

export default Note
